import {VehicleSupertype} from './vehicle-supertype';

export class VehicleType {
	public id: string;
	public name: string;
	public prefix: string;
	public supertype: VehicleSupertype;

	constructor(server_obj) {
		this.prefix = 'vty_';
		if (server_obj) {
			this.id = server_obj[this.prefix + 'id'];
			this.name = server_obj[this.prefix + 'name'];
			this.supertype = new VehicleSupertype(server_obj);

		} else {

			this.supertype = new VehicleSupertype(undefined);
		}
	}
}
